export function isNumber(o: unknown): o is number {
	return typeof o === 'number';
}

export function isObject<T = Record<string, unknown>>(o: unknown): o is T {
	return typeof o === 'object';
}

export function isString(o: unknown): o is string {
	return typeof o === 'string';
}

export function isStringAndNotNullOrEmpty(o: unknown): boolean {
	return Boolean(o) && isString(o) && o.length > 0;
}

export type FunctionType = (...args: unknown[]) => unknown;
export function isFunction<T extends FunctionType = FunctionType>(o: unknown): o is T {
	return typeof o === 'function';
}

export function isNullOrUndefined(o: unknown): o is null | undefined {
	return o === null || o === undefined;
}
